import OrganizationApi from "@/api/organizationApi";
import StorageApi from "@/api/storageApi";

export default {
  state: {
    organizationsList: [],
    organizationSelected: undefined,
    organizationMachineGroupsList: [],
    organizationMachineList: [],
    organizationRoles: [],
    rolesLoading: false
  },
  getters: {
    all(state) {
      return state.organizationsList;
    },
    selected(state) {
      return state.organizationSelected;
    },
    getMachineGroups: state => state.organizationMachineGroupsList,
    getRoles(state) {
      return state.organizationRoles;
    }
  },
  actions: {
    async setOrganizations() {
      //const api = new OrganizationApi();
      /*const organizations = await api.getOrganizations();
      commit("SET_ORGANIZATIONS", organizations);*/
    },
    async selectOrganization({ state, commit, dispatch }, args) {
      const selectedOrganization = state.organizationsList.find(
        organization => organization.BusinessCode === args
      );
      if (
        selectedOrganization &&
        state.organizationSelected &&
        state.organizationSelected.BusinessCode !== selectedOrganization.BusinessCode
      ) {
        dispatch("clearOrganization");
      }

      const api = new OrganizationApi();
      await api.getOrganization(args).then(organization => {
        commit("SELECT_ORGANIZATION", organization);

        // Set full list machines list for MachineSettings
        //dispatch("MachineSettings/setMachineList", null, { root: true });
      });
    },

    // INIT ROLES: need user initialized
    setRoles({ state, commit }, args) {
      try {
        if (!state.rolesLoading) {
          state.rolesLoading = true;
          const api = new OrganizationApi();
          api.getRoles(args).then(roles => {
            state.rolesLoading = false;
            commit("SET_ROLES", roles);
          });
        }
      } catch (e) {
        console.error("Get Organization Roles failed");
      }
    },

    clearOrganization({ dispatch }) {
      dispatch("User/logout", null, { root: true });
      dispatch("Machine/clearMachineData", null, { root: true });
    },

    async updateOrganization({ state, commit }, params) {
      const api = new OrganizationApi();
      const storageApi = new StorageApi();
      const { logoFile, mapViewFile } = params;

      let result = null;

      try {
        if (logoFile) {
          //Upload image Logo
          const responseUpload = await storageApi.uploadFile(logoFile.file);
          params.Logo_Url = responseUpload.link ? responseUpload.link : "";

          delete params.logoFile;
        }

        if (mapViewFile) {
          //Upload image Logo
          const responseUpload = await storageApi.uploadFile(mapViewFile.file);
          const BackgroundUrl = responseUpload && responseUpload.link ? responseUpload.link : "";

          params.Map_View = {
            ...params.Map_View,
            BackgroundUrl
          };

          delete params.mapViewFile;
        }

        // Update Organization
        await api.updateOrganization(state.organizationSelected.BusinessCode, params);
        result = { ...state.organizationSelected, ...params };

        commit("SELECT_ORGANIZATION", result);
      } catch (error) {
        // Error on update user
        console.error(error);
      }

      return result;
    }
  },
  mutations: {
    SELECT_ORGANIZATION: (state, payload) => {
      state.organizationSelected = payload;
    },
    SET_ORGANIZATIONS: (state, organizations) => {
      state.organizationsList = organizations;
    },
    SET_ROLES: (state, payload) => {
      state.organizationRoles = payload;
    }
  },
  namespaced: true
};
